import React from 'react';
import { useSelector } from 'react-redux';

const DeliveryPartnerSummaryPrint = () => {
  const decimalPosition = localStorage.getItem("decimalPosition");
  const deliveryPartnerSummary = useSelector((state) => state.posReportshiftSlice.deliveryPartnerSummary);
  const { showSubHeaders } = useSelector((state) => state.posReportshiftSlice);

  // Add print-specific styles directly in the component


  return (
    <>
      {/* Add print styles */}
      {/* <style>{printStyles}</style> */}
      
      <div className="new-global-table-container delivery-partner-container">
        <div className="bill-main-head">
          <h5>Delivery Partners</h5> 
          <h5>Amount</h5>
        </div>

        {deliveryPartnerSummary ? (
          deliveryPartnerSummary?.map((partner, index) => (
            <React.Fragment key={partner?._id}>
              <div className="bill-sub-head">
                <h5>{partner?.partner}</h5>
                <h5>{partner?.total?.toFixed(decimalPosition)}</h5>
              </div>

              {showSubHeaders && (
                <table>
                  <thead>
                    <tr>
                      <th>Order No</th>
                      <th>Date</th>
                      <th>Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partner?.data?.map((order, orderIndex) => (
                      <tr key={orderIndex}>
                        <td>{order?.orderNo}</td>
                        <td>{order?.date}</td>
                        <td>{order?.amount?.toFixed(decimalPosition)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </React.Fragment>
          ))
        ) : (
          <div className="bill-sub-head" style={{justifyContent:"center"}}>
            <h5>No Records</h5>
          </div>
        )}
      </div>
    </>
  );
};

export default DeliveryPartnerSummaryPrint;